import BaseAPIService from '../base/base-api-service';
import baseModel from 'src/model/base.model';

class ProductInformationService extends BaseAPIService<any> {
  public endpoint: string = '/accountapp/v1/email/productinquiry';

  constructor() {
    super(baseModel);
  }

  public sendProductInformation(
    brand: null,
    model: null,
    partNumber: null,
    contactNumber: string = null,
    email: string = ''
  ): Promise<any> {
    return this.create(`${this.endpoint}`, {
      brand,
      model,
      partNumber,
      contactNumber,
      email
    });
  }
}

const ProductInformationServiceInstance = new ProductInformationService();
Object.freeze(ProductInformationServiceInstance);

export default ProductInformationServiceInstance;
